module.exports = __webpack_public_path__ + "img/symbol_1.aed72026.png";